export default __webpack_public_path__ + "38a11854d7963dd4b9a75410d1a0684e79e3b311732597fd46a5a78c7763c5bb.svg";